import Image from '../../components/shared/image/image';
import './signIn.scss';
import logo from '../../images/logo.png';
import { ReactComponent as chevronRight } from '../../icons/chevron_right.svg';
import { ReactComponent as checkCircle } from '../../icons/check_circle.svg';
import Wrapper from '../../components/shared/wrapper/wrapper';
import FormField from '../../components/formField/formField';
import CheckboxField from '../../components/checkboxField/checkboxField';
import ButtonField from '../../components/buttonField/buttonField';
import { BtnProps, classNameBtn } from '../../components/shared/button/types/buttonProps';
import { useContext, useState } from 'react';
import { Login } from '../../services/signInService/signInService';
import { FormFieldProps } from '../../components/formField/types/formFieldProps';
import UseDebounce from '../../helpers/debounce';
import { CheckboxFieldProps } from '../../components/checkboxField/types/checkboxFieldProps';
import { signInProps } from './types/signInProps';
import { ButtonFieldProps } from '../../components/buttonField/types/buttonFieldProps';
import { stylizationVerticalAlignMargin } from '../../components/shared/stylization';
import AuthContext from '../../contexts/authContext';
import { apiContext } from '../../contexts/apiContext';
import { ToastContainer } from 'react-toastify';
import CloseButton from '../../components/snackbar/closeButton';
import { notifyWarn } from '../../components/snackbar/snackbar';
import esriId from "@arcgis/core/identity/IdentityManager.js";
import esriConfig from "@arcgis/core/config.js";
import { configValidation } from '../../helpers/validation/validation';
import { getOrInitializeUserConfig, unRememberMe } from '../../helpers/userConfig';
import { getUserConfig, setLoggedUser, setUserConfigIdb } from '../../database/indexedDbReadWrite';

const SignIn = (props: signInProps) => {
    const [userName, setUserName] = useState(localStorage.getItem("userNameSOPO") !== null ? localStorage.getItem("userNameSOPO") as string : "");
    const [password, setPassword] = useState(localStorage.getItem("passwordSOPO") !== null ? localStorage.getItem("passwordSOPO") as string : "");
    const [validationError, setValidationError] = useState(false);
    const [buttonLoginDisabled, setButtonLoginDisabled] = useState(false);
    const [checked, setChecked] = useState(localStorage.getItem("remberMeSOPO") === 'true' ? true : false);
    const { setAuthenticated, setUsername, setUserConfig, setOnlineMode } = useContext(AuthContext);
    const { apiUrl, apiVersion, portalUrl, arcGisServerUrl } = useContext(apiContext);

    const rememberMe = () => {
        localStorage.setItem("remberMeSOPO", checked.toString());
        localStorage.setItem("userNameSOPO", userName);
        localStorage.setItem("passwordSOPO", password);
    }

    const LoginClick = (event: React.SyntheticEvent<HTMLInputElement>) => {
        setValidationError(false);
        setButtonLoginDisabled(true);
        sessionStorage.setItem("isActiveLoginSOPO", userName);
        Login(userName, password, apiUrl, apiVersion, null, null).then((res: any) => {
            if (res.data && (typeof(res.data) === 'string') && (res.data as string).includes("Zbyt wiele")) {
                setValidationError(true);
                notifyWarn({ message: res.data });
            }
            else {
                sessionStorage.setItem("SOPOtoken", res.data.token);
                sessionStorage.setItem("SOPOGuidSession", res.data.guidSession);
                esriId.registerToken({
                    server: arcGisServerUrl,
                    token: res.data.token
                });
                esriConfig.portalUrl = portalUrl;
                esriConfig.request.interceptors?.push({
                    // set the `urls` property to the URL of the FeatureLayer so that this
                    // interceptor only applies to requests made to the FeatureLayer URL
                    urls: portalUrl + "/sharing/rest/community/users/" + userName,
                    // use the BeforeInterceptorCallback to add token to query
                    before: function (params) {
                        params.requestOptions.query.token = res.data.token;
                    },
                });
                setLoggedUser({ name: "logged", val: userName });
                setAuthenticated(true);
                setUsername(userName);

                // Get user config for auth context (if config doesn't exist, a default one is created)
                getOrInitializeUserConfig(userName).then((res: any) => {
                    res.config.rememberLogInDetails = checked;
                    setUserConfig(res.config);
                    setUserConfigIdb({ username: userName, name: res.name, config: res.config }).then((response) => {
                    });
                    setOnlineMode(res.config.automaticOnlineMode);
                    sessionStorage.setItem("SOPOonline", Boolean(res?.config.automaticOnlineMode).toString());
                });
            }
        }, (reject: any) => {
            if (reject.response !== undefined && reject.response.status === 400) {
                notifyWarn({ message: reject.response.data });
            }
            else {
                if (reject !== null && reject.code && reject.code === "ERR_NETWORK") {
                    getUserConfig(userName).then((response) => {
                        if (response) {
                            setLoggedUser({ name: "logged", val: userName });
                            setAuthenticated(true);
                            setUsername(userName);
                            // Get user config for auth context (if config doesn't exist, a default one is created)
                            getOrInitializeUserConfig(userName).then((res: any) => {
                                res.config.rememberLogInDetails = checked;
                                setUserConfig(res.config);
                                setUserConfigIdb({ username: userName, name: res.name, config: res.config }).then((response) => {
                                });
                                setOnlineMode(res.config.automaticOnlineMode);
                                sessionStorage.setItem("SOPOonline", Boolean(false).toString());
                            });
                        }
                        else {
                            notifyWarn({ message: "Brak połączenia z serwerem oraz brak konfiguracji użytkownika w trybie offline, należy sprawdzić połączenie z internetem lub serwerem i zalogować się online" })
                        }
                    })
                }
                else {
                    setValidationError(true);
                }
            }
        }).finally(() => {
            setButtonLoginDisabled(false);
            if (checked) {
                rememberMe();
            }
        })
    }

    const onChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(!checked);
        if (checked) {
            unRememberMe();
        }
    }

    const handleLoginClick = (event: any) => {
        UseDebounce(LoginClick(event), 100);
    }

    var BtnProps: BtnProps = {
        className: classNameBtn.Large,
        onClick: handleLoginClick,
        disabled: buttonLoginDisabled
    }

    var checkboxFieldStyle: React.CSSProperties = {
        width: '100%',
        textAlign: 'left',
        paddingTop: '5px'
    }

    var Validation: configValidation = {
        required: true,
        minCharacters: {
            minNumberOfCharacters: 8,
            errorMsg: "Należy wpisać minimum 8 znaków"
        }
    }

    const keyboardNavLogin = (event: any) => {
        // Enter
        if (event.keyCode === 13) handleLoginClick(event);
    }

    var formFieldPropsLogin: FormFieldProps = {
        configValidationWarnings: Validation,
        validationError: validationError,
        labelName: 'Login',
        inputPlaceholder: 'Wpisz nazwę użytkownika',
        tipText: 'Wpisano błędne dane do logowania',
        value: userName,
        setValue: setUserName,
        additionalIcon: checkCircle,
        pristine: true,
        onKeyDown: keyboardNavLogin,
        autoFocus: true,
        debounceOff: true
    }

    var formFieldPropsPassword: FormFieldProps = {
        configValidation: Validation,
        validationError: validationError,
        labelName: 'Hasło',
        inputPlaceholder: 'Wpisz hasło',
        type: 'password',
        tipText: 'Wpisano błędne dane do logowania',
        value: password,
        setValue: setPassword,
        additionalIcon: checkCircle,
        pristine: true,
        onKeyDown: keyboardNavLogin,
        debounceOff: true
    }

    var checkboxFieldProps: CheckboxFieldProps = {
        disabled: buttonLoginDisabled,
        labelName: 'Zapamiętaj hasło',
        style: checkboxFieldStyle,
        inputChecked: checked,
        onChange: onChangeCheckbox
    }

    var ButtonFieldProps: ButtonFieldProps = {
        BtnProps: BtnProps,
        placeHolder: "Zaloguj się",
        placeHolderStyle: stylizationVerticalAlignMargin,
        additionalIcon: chevronRight
    }

    return (
        <div className='wrapper'>
            <div className='signIn'>
                <Wrapper className='logoWrapper' children={<Image src={logo} />} />
                <FormField {...formFieldPropsLogin}></FormField>
                <FormField {...formFieldPropsPassword}></FormField>
                <CheckboxField {...checkboxFieldProps} />
                <ButtonField {...ButtonFieldProps} />
            </div>
            <ToastContainer closeButton={CloseButton} />
        </div>
    )
}

export default SignIn;